module.exports = __webpack_public_path__ + "media/src/public/images/icons/mstile-150x150-a4abbc8d0ba42534666c33cfe8e07af6.png";